<template>
    <div>
        <barra-titulo 
            :titulo="titulo" 
            :itens="breadcrumb" 
        />
        <formulario />
    </div>
</template>
<script>
export default {
    components: {
        Formulario: () => import('../components/Formulario')
    },
    data() {
        return {
            breadcrumb: [
                {
                    descricao: 'Contratos de serviços',
                    url: '/contratos_servicos'
                },
                {
                    descricao: 'Adicionar'
                }
            ],
            titulo: this.$route.fullPath.includes('renovar') ? 'Renovar contrato' : 'Adicionar contrato'
        }
    }
}
</script>
<style>
    
</style>